export default {
    feed: {
        title: 'New',
        type: {
            meditation: 'Practice',
            minute: 'Mindful Moment'
        }
    }
};
